import React from 'react'

import type { HTMLAttributes } from 'react'
import styled from 'styled-components'

import { Tooltip } from '@components/ui/Tooltips'

const OverflowTextSpan = styled.span<{ $maxWidth?: number }>`
  display: block;
  max-width: ${({ $maxWidth }) => ($maxWidth != undefined ? `${$maxWidth}px` : '100%')};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export interface OverflowTextWithTooltipProps extends HTMLAttributes<HTMLSpanElement> {
  children: NonNullable<React.ReactNode>
  className?: string
  withPortal?: boolean
  $maxWidth?: number
}

export function OverflowTextWithTooltip({
  children,
  withPortal = false,
  className,
  ...rest
}: OverflowTextWithTooltipProps) {
  const [overflowActive, setOverflowActive] = React.useState(false)

  const textNode = React.useMemo(() => {
    const onMouseEnterHandler: React.MouseEventHandler<HTMLSpanElement> = event => {
      const { offsetWidth, scrollWidth } = event.currentTarget

      setOverflowActive(offsetWidth < scrollWidth)
    }

    const onMouseLeaveHandler: React.MouseEventHandler<HTMLSpanElement> = () => {
      setOverflowActive(false)
    }

    return (
      <OverflowTextSpan {...rest} onMouseEnter={onMouseEnterHandler} onMouseLeave={onMouseLeaveHandler}>
        {children}
      </OverflowTextSpan>
    )
  }, [children, rest])

  if (overflowActive) {
    return (
      <Tooltip title={children} withPortal={withPortal}>
        {textNode}
      </Tooltip>
    )
  }

  return textNode
}
